export default function StatusDot({ isLive, uptime, compact }) {
  if (compact) {
    return (
      <span style={{
        width: 8, height: 8, borderRadius: '50%',
        background: isLive ? 'var(--green)' : 'var(--red)',
        boxShadow: isLive ? '0 0 8px var(--green)' : 'none',
        display: 'inline-block', flexShrink: 0,
      }} />
    );
  }

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      fontSize: 12, fontWeight: 500,
      color: isLive ? 'var(--green)' : 'var(--red)',
      padding: '3px 10px 3px 8px',
      borderRadius: 99,
      background: isLive ? 'rgba(34,197,94,0.08)' : 'rgba(239,68,68,0.08)',
      border: `1px solid ${isLive ? 'rgba(34,197,94,0.2)' : 'rgba(239,68,68,0.2)'}`,
    }}>
      <span style={{
        width: 6, height: 6, borderRadius: '50%',
        background: isLive ? 'var(--green)' : 'var(--red)',
        boxShadow: isLive ? '0 0 6px var(--green)' : 'none',
        display: 'inline-block',
      }} />
      {isLive ? `Online${uptime != null ? ` \u00b7 ${uptime?.toFixed(0)}%` : ''}` : 'Offline'}
    </span>
  );
}
